<h1 class="primary" mat-dialog-title>
  @if (data.node.isRoot) {
    {{ data.node.name }}
  }
  @if (!data.node.isRoot) {
    <input
      (ngModelChange)="nameChanged = true; refreshSaveBtnState()"
      matInput
      [(ngModel)]="data.node.name"
      placeholder="{{ 'group.name_property' | transloco }}"
      cdkFocusInitial
      />
  }
</h1>
<div mat-dialog-content>
  @if (!data.node.isRoot) {
    <input
      matInput
      (ngModelChange)="descriptionChanged = true; refreshSaveBtnState()"
      [(ngModel)]="data.node.description"
      placeholder="{{ 'group.description_property' | transloco }}"
      class="mb-3 text-black-50"
      />
  }
  @if (!data.node.isRoot) {
    <p>
      {{ "group.choose_hierarchy_action" | transloco }}
    </p>
  }
  @if (!data.node.isRoot) {
    <mat-radio-group
      (ngModelChange)="refreshSaveBtnState()"
      [(ngModel)]="dialogData.action"
      class="mt-3"
      >
      <mat-radio-button class="" value="editGroup">{{
        "operations.edit" | transloco
      }}</mat-radio-button>
      <br />
      <mat-radio-button class="mt-3" value="addGroup">{{
        "group.add_group" | transloco
      }}</mat-radio-button>
      <br />
      <mat-radio-button class="mt-3" value="addAsset">{{
        "group.add_assets" | transloco
      }}</mat-radio-button>
    </mat-radio-group>
  }
  @if (dialogData.action === 'addAsset') {
    <div class="w-100 mt-3">
      <loren-asset-selection
        [allAssets]="assets$ | async"
        [selectedAssets]="dialogData.selectedAssets"
      (changedAssetSelection)="
        dialogData.selectedAssets = $event; refreshSaveBtnState()
      "
        >
      </loren-asset-selection>
    </div>
  }
  @if (dialogData.action === 'addGroup') {
    <mat-form-field class="w-100 mt-3 loren-form-field">
      <mat-label>{{ "group.name_property" | transloco }}</mat-label>
      <input
        matInput
        (ngModelChange)="refreshSaveBtnState()"
        [(ngModel)]="dialogData.newGroupName"
        placeholder=""
        />
    </mat-form-field>
    <mat-form-field class="w-100 mt-1 loren-form-field">
      <mat-label>{{ "group.description_property" | transloco }}</mat-label>
      <input
        matInput
        (ngModelChange)="refreshSaveBtnState()"
        [(ngModel)]="dialogData.newGroupDescription"
        placeholder=""
        />
    </mat-form-field>
  }
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">
    {{ "operations.cancel" | transloco }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    [disabled]="disableSaveButton"
    (click)="save()"
    >
    {{ "operations.save" | transloco }}
  </button>
</div>
